'use client'

import { useState } from 'react'

import { Copy } from 'lucide-react'

export default function CopyDraftModeButton() {
  const [copied, setCopied] = useState(false)
  const handleCopyLink = async () => {
    try {
      const currentPath = window.location.pathname

      console.log(currentPath)
      const url = `${process.env.NEXT_PUBLIC_SITE_URL}/api/preview?secret=${process.env.NEXT_PUBLIC_STRAPI_API_PREVIEW_SECRET}&slug=${currentPath}`

      await navigator.clipboard.writeText(url.toString())
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      console.error('Failed to copy link:', error)
    }
  }

  return (
    <button
      onClick={handleCopyLink}
      className="flex items-center justify-center hover:opacity-85"
    >
      {!copied && <Copy className="mr-1 size-3" />}
      {copied ? 'Link copied!' : 'Copy link'}
    </button>
  )
}
